/**
 * Разбор результата занятия.
 *
 * Единица режима — клавиша, поэтому нажатия относятся к символам, а не к
 * элементам упражнения: сочетание «апр» — это три разные клавиши, и общий
 * итог по нему ничего бы не сказал о том, какая из них не даётся.
 *
 * Сама арифметика — общая: сопоставление нажатий символам живёт в
 * `typing-engine`, обновление состояния единиц — в `learning-engine`. Здесь
 * остаётся только то, что относится именно к «Основам»: символ занятия — это
 * клавиша.
 */

import type {
  KeystrokeEvent,
  MasteryStat,
  MasteryUnit,
  TypingError,
  UnitOutcome,
} from '@type2x/shared-contracts';
import { toMasteryUnitId } from '@type2x/shared-contracts';
import { collectCharacterOutcomes } from '@type2x/typing-engine';
import { applyUnitOutcomes, type LearningConfig } from '@type2x/learning-engine';

import type { FundamentalsExercise } from '../contracts/fundamentals.js';

/** Сопоставляет нажатия клавишам упражнения. */
export function collectKeyOutcomes(
  exercise: FundamentalsExercise,
  events: readonly KeystrokeEvent[],
  errors: readonly TypingError[],
): UnitOutcome[] {
  return collectCharacterOutcomes(exercise.text, events, errors).map((outcome) => ({
    unitId: toMasteryUnitId(`key:${outcome.character}`),
    attempts: outcome.attempts,
    errors: outcome.errors,
    medianLatencyMs: outcome.medianLatencyMs,
    corrections: outcome.corrections,
  }));
}

/** Обновляет статистику клавиш по итогам занятия. */
export function applyKeyOutcomes(
  units: readonly MasteryUnit[],
  stats: Readonly<Record<string, MasteryStat>>,
  outcomes: readonly UnitOutcome[],
  config: LearningConfig,
  nowIso: string,
): MasteryStat[] {
  return applyUnitOutcomes(units, stats, outcomes, config, nowIso);
}
